var map = {
	"./background-photo.png": 9527,
	"./certificate.svg": 7031,
	"./clip.svg": 6980,
	"./close-2.svg": 4507,
	"./close-mobile.svg": 3225,
	"./close.svg": 8298,
	"./down-arrow.svg": 9778,
	"./download-arrow.png": 7060,
	"./fast-delivery.svg": 2813,
	"./file-icon.svg": 9462,
	"./gallery-1.jpg": 5510,
	"./gallery-2.jpg": 5857,
	"./gallery-3.jpg": 7812,
	"./gallery-4.jpg": 2751,
	"./geolocation.svg": 4452,
	"./inside-factory-1.jpg": 3531,
	"./inside-factory-2.jpg": 2908,
	"./inst.svg": 1782,
	"./item-excavator.svg": 4299,
	"./item-factory.svg": 4486,
	"./item-file.svg": 3110,
	"./item-lathe.svg": 3522,
	"./item-sb.svg": 7447,
	"./item-welding.svg": 556,
	"./location.svg": 9195,
	"./logo.png": 5549,
	"./map-icon.svg": 8430,
	"./menu.svg": 3231,
	"./new-service4.svg": 3650,
	"./partner-1.svg": 3074,
	"./partner-10.svg": 1102,
	"./partner-2.svg": 2561,
	"./partner-3.svg": 7024,
	"./partner-4.svg": 6559,
	"./partner-5.svg": 9182,
	"./partner-6.svg": 7005,
	"./partner-7.svg": 3884,
	"./partner-8.svg": 699,
	"./partner-9.svg": 330,
	"./pay.svg": 2756,
	"./photo-car.png": 8039,
	"./pickup-face-truck.svg": 7862,
	"./quality.svg": 8125,
	"./repair-dryer.svg": 2852,
	"./repair-dust.svg": 618,
	"./rocket.svg": 1630,
	"./rvz.svg": 3384,
	"./show-on-map.svg": 568,
	"./stopwatch.svg": 8635,
	"./ten-years.svg": 3646,
	"./traktor.jpg": 9491,
	"./truck.svg": 2311,
	"./yellow-babina.png": 8968,
	"./zavod-2.jpg": 7577,
	"./zavod-blue.jpg": 735,
	"./zavodik.jpg": 4808,
	"./zoom-minus.svg": 564,
	"./zoom-plus.svg": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;